import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { TemplateWizard } from "@/modules/proposal-builder/components/templates/TemplateWizard";
import { useCreateTemplate } from "@/modules/proposal-builder/hooks/useProposalTemplates";

export const Route = createFileRoute("/proposal-builder/templates/new")({
  component: ProposalTemplateNewRoute,
});

function ProposalTemplateNewRoute() {
  const navigate = useNavigate();
  const createTemplate = useCreateTemplate();

  return (
    <TemplateWizard
      mode="create"
      isSubmitting={createTemplate.isPending}
      onCancel={() => {
        navigate({ to: "/proposal-builder/templates" });
      }}
      onSubmit={async (payload) => {
        const created = await createTemplate.mutateAsync(payload);

        navigate({
          to: "/proposal-builder/templates/$id",
          params: { id: created.id },
        });
      }}
    />
  );
}